<template>
  <div class="m-card-primary m-the-modal-content">
    <form
      autocomplete="off"
      name="the-modal-form"
      @submit.prevent="updateFamilia"
    >
      <header class="m-the-modal-header">
        <h5>{{ $t('mEditionMapEnrollmentsFamiliesModalEdit.title') }}</h5>
        <AtomButtonTheModalCloseIcon/>
      </header>
      <section class="m-the-modal-section">
        <AtomInputPrimary
          v-model="familia.nombre"
          :inputError="$v.familia.nombre.$error"
          :label="$t('mEditionMapEnrollmentsFamiliesModalEdit.inputs.nombre.label')"
          :messageError="messageErrorNombre"
          name="nombre"
          :placeholder="$t('mEditionMapEnrollmentsFamiliesModalEdit.inputs.nombre.placeholder')"
          type="text"
          @blur="$v.familia.nombre.$touch()"
        />
        <p>
          <AtomAvatarEdition
            avatar-class="xlarge"
            :avatar-img="familia.logo"
            :is-family-avatar="true"
            :user-info="{email: familia.nombre, fecha_alta: familia.fecha_alta}"
            wrapper-class="margin-right-large"
            @changeAvatarImage="changeAvatarImage"
          />
        </p>
      </section>
      <footer class="m-the-modal-footer">
        <AtomButtonTheModalCancelAction :cancel-text="$t('mEditionMapEnrollmentsFamiliesModalEdit.buttonCancel')"/>
        <AtomButtonPrimary :button-primary="buttonPrimary"/>
      </footer>
    </form>
  </div>
</template>

<script>
import { maxLength, minLength, required } from 'vuelidate/lib/validators'

export default {
  name: 'MoleculeEditionMapEnrollmentsFamiliesModalEdit',

  data () {
    return {
      academiaId: '',

      buttonPrimary: {
        action: this.$t('mEditionMapEnrollmentsFamiliesModalEdit.buttonPrimary'),
        class: 'a-button-assets-primary',
        sending: false,
        type: 'submit'
      },

      familia: {
        fecha_alta: '',
        id: '',
        logo: '',
        nombre: ''
      },

      showLoadingState: true
    }
  },

  validations: {
    familia: {
      nombre: {
        maxLength: maxLength(60),
        minLength: minLength(1),
        required
      }
    }
  },

  computed: {
    messageErrorNombre () {
      return this.$validation.getValidationMessage('mEditionMapEnrollmentsFamiliesModalEdit', this.$v.familia.nombre, 'nombre')
    }
  },

  created () {
    this.academiaId = this.$store.getters.getAcademyData.id
    this.proyectoId = this.$route.params.id
    Object.assign(this.familia, this.$modal.element)
  },

  methods: {
    changeAvatarImage (avatarImg) {
      this.familia.logo = avatarImg
    },

    updateFamilia () {
      this.$v.$touch()
      if (!this.$v.$invalid && !this.buttonPrimary.sending) {
        this.buttonPrimary.sending = true
        this.$services.update('familia', 'updateFamilia', { nombre: this.familia.nombre, logo: this.familia.logo }, [this.familia.id])
          .then(response => {
            this.$modal.updateData()
            this.$alerts.pushAlert('mEditionMapEnrollmentsFamiliesModalEdit', 'updateFamilia', 'success')
            this.$modal.closeModal()
            this.$license.readAcademiaRecursosUsados()
            this.buttonPrimary.sending = false
          })
          .catch(error => {
            console.log('Este es el error: ' + error)
            this.$license.readAcademiaRecursosUsados()
            this.$alerts.pushAlert('mEditionMapEnrollmentsFamiliesModalEdit', 'updateFamilia', 'error', 'a-alert-danger')
            this.buttonPrimary.sending = false
          })
      }
    }
  }
}
</script>
